import { useState, useCallback } from 'react'
import Box from '@mui/material/Box'
import ShareCodeInput from './ShareCodeInput'
import api from 'services/api'
import LoadingButton from '@mui/lab/LoadingButton'
import useToast from 'hooks/useToast'
import Heading from './Heading'

const AnimatedVideo = () => {
  const toast = useToast()
  const [shareLink, setShareLink] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const createVideo = useCallback(async () => {
    if (!shareLink) return

    const shareCode = shareLink.split('/').slice(-1)[0]
    try {
      setIsLoading(true)
      const url = await api.animatedVideos.getAnimatedVideo(shareCode)
      window.open(url, '_blank')
      setShareLink('')
    } catch (e) {
      toast({ message: e.message, severity: 'error' })
    } finally {
      setIsLoading(false)
    }
  }, [shareLink, toast])

  return (
    <Box>
      <Heading text="1. Enter share link" />
      <ShareCodeInput shareLink={shareLink} onChange={setShareLink} />
      <Heading text="2. Create the vid" />
      <LoadingButton
        variant="contained"
        disabled={!shareLink}
        onClick={createVideo}
        loading={isLoading}
      >
        Create
      </LoadingButton>
    </Box>
  )
}

export default AnimatedVideo
